import { useNewTranslations } from '@/common/translations';
import { Section } from '@/ui/components';

import { OtherMatchInformation } from '../../../components';
import { ApiWidgetType, StatsTypes } from '../../../constants';
import { useStatsData } from '../../../hooks';

const VenueReferee = () => {
  const translate = useNewTranslations();
  const { widget } = useStatsData({
    shouldFetchTeamsData: false,
    widgetType: StatsTypes.VENUE_REFEREE,
  });

  if (!widget || widget.type !== ApiWidgetType.VENUE_REFEREE || !widget?.data) {
    return null;
  }

  const referee = widget.data.referee
    ? {
        name: widget.data.referee.name,
        flagUrl: widget.data.referee.flag,
      }
    : undefined;

  return (
    <Section name={translate('PreMatchStats.VenueAndReferee')}>
      <OtherMatchInformation
        stadium={{
          name: widget.data.venue.name,
          capacity: widget.data.venue.capacity,
        }}
        referee={referee}
      />
    </Section>
  );
};

export default VenueReferee;
